export default "__VITE_ASSET__Du7ZK9XD__"